<script>import { cx } from "@emotion/css";
import { useTwistTheme, ResponsiveVars } from "..";
const twistTheme = useTwistTheme();
let responsiveVarsClassName;
export let colStart = 1;
export let colSpan = $twistTheme.defaults.TwistGridItem.colSpan;
export let rowStart = 1;
export let rowSpan = 1;
export let display = void 0;
$: {
  const responsiveVars = new ResponsiveVars().addResponsive("col-span", colSpan).addResponsive("display", display);
  if (colStart) {
    responsiveVars.addResponsive("col-start", colStart);
  }
  if (rowStart) {
    responsiveVars.addResponsive("row-start", rowStart);
  }
  if (rowSpan) {
    responsiveVars.addResponsive("row-span", rowSpan);
  }
  responsiveVarsClassName = responsiveVars.toCSS();
}
</script>

<div class={cx('grid-item', responsiveVarsClassName)}>
  <slot />
</div>

<style>
  .grid-item {
    grid-column-start: var(--col-start);
    grid-column-end: span var(--col-span);
    grid-row-start: var(--row-start);
    grid-row-end: span var(--row-span);

    display: var(--display);
  }
</style>
